import { CheckSquareOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import moment from "moment";

const Preview = (props) => {
  const timeSlot = props.previewData?.time_slot || props.time_slot || {};
  const previewEmployment = props.previewData?.employments || props.employments || [];
  const shiftDates = props.dates || [];
  const breaks = timeSlot.breaks || props.breaks || [];
  const hasBreaks = breaks.length > 0;

  const valueOrDash = (value) => {
    if (value === 0 || value) {
      return value?.format ? value.format("hh:mm a") : value;
    }

    return "-";
  };
  const yesNo = (value) => value ? "Yes" : "No";
  const minutes = (value) => value === 0 || value ? `${ value } min` : "-";
  const employeeName = (employee) => employee.name || employee.full_name || "Employee";
  const employeeDesignation = (employee) => employee.designation_name || employee.designation || "";
  const employeeInitials = (employee) => employeeName(employee)
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();

  const Detail = ({ label, children, emphasized = false }) => (
    <div className="roster-review-detail">
      <span className="roster-review-label">{ label }</span>
      <strong className={ emphasized ? "roster-review-value roster-review-value-strong" : "roster-review-value" }>{ children }</strong>
    </div>
  );

  return (
    <div className="roster-review">
      <div className="roster-review-alert">
        <CheckSquareOutlined />
        <span>Review everything below, then Submit. To change any detail, use Back.</span>
      </div>

      <section className="roster-review-card">
        <div className="roster-review-card-title">Shift details</div>
        <div className="roster-review-grid roster-review-grid-top">
          <Detail label="Name" emphasized>{ valueOrDash(timeSlot.name) }</Detail>
          <Detail label="Start Time ?">{ valueOrDash(timeSlot.start) }</Detail>
          <Detail label="End Time ?">{ valueOrDash(timeSlot.end) }</Detail>
        </div>
        <div className="roster-review-grid roster-review-grid-four">
          <Detail label="Is Night ?"><span className="roster-review-pill">{ yesNo(timeSlot.is_night) }</span></Detail>
          <Detail label="Flexible ?"><span className="roster-review-pill">{ yesNo(timeSlot.is_flexible) }</span></Detail>
          <Detail label="Full Overtime ?"><span className="roster-review-pill">{ yesNo(timeSlot.is_full_overtime_slot) }</span></Detail>
          <Detail label="Flexible Hrs ?">{ valueOrDash(timeSlot.flexible_minutes) }</Detail>
        </div>
        <div className="roster-review-grid roster-review-grid-four">
          <Detail label="Late Buffer ?">{ minutes(timeSlot.end_buffer_minutes) }</Detail>
          <Detail label="Early Buffer ?">{ minutes(timeSlot.start_buffer_minutes) }</Detail>
          <Detail label="Punch Buffer Start ?">{ minutes(timeSlot.punch_start_buffer_minutes) }</Detail>
          <Detail label="Punch Buffer End ?">{ minutes(timeSlot.punch_end_buffer_minutes) }</Detail>
        </div>
      </section>

      { hasBreaks ?
        <section className="roster-review-card">
          <div className="roster-review-card-title">Break</div>
          { breaks.map((eachBreak, index) => (
            <div className="roster-review-grid roster-review-grid-four" key={ eachBreak.id || `${ eachBreak.name }-${ index }` }>
              <Detail label="Name" emphasized>{ valueOrDash(eachBreak.name) }</Detail>
              <Detail label="From ?">{ valueOrDash(eachBreak.start) }</Detail>
              <Detail label="To ?">{ valueOrDash(eachBreak.end) }</Detail>
              <Detail label="Inclusive ?"><span className="roster-review-pill">{ yesNo(eachBreak.is_inclusive) }</span></Detail>
            </div>
          )) }
        </section>
        : null }

      <Row gutter={ 16 }>
        <Col lg={ 12 } sm={ 24 } xs={ 24 }>
          <section className="roster-review-card roster-review-list-card">
            <div className="roster-review-card-title">
              <span>Employees</span>
              <span className="roster-review-count">{ previewEmployment.length }</span>
            </div>
            <div className="roster-review-list">
              { previewEmployment.map((employee) => (
                <div className="roster-review-employee" key={ employee.id }>
                  <span className="roster-review-avatar">{ employeeInitials(employee) }</span>
                  <span className="roster-review-employee-meta">
                    <strong>{ employeeName(employee) }</strong>
                    <small>{ employeeDesignation(employee) }</small>
                  </span>
                </div>
              )) }
            </div>
          </section>
        </Col>

        <Col lg={ 12 } sm={ 24 } xs={ 24 }>
          <section className="roster-review-card roster-review-list-card">
            <div className="roster-review-card-title">Shifts</div>
            <table className="roster-review-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Day</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                { shiftDates.map((date, index) => {
                  const currentDate = moment(date, 'YYYY-MM-DD');

                  return (
                    <tr key={ date }>
                      <td>{ String(index + 1).padStart(2, "0") }</td>
                      <td>{ currentDate.format('dddd') }</td>
                      <td>{ currentDate.format('MMM D, YYYY') }</td>
                    </tr>
                  );
                }) }
              </tbody>
            </table>
          </section>
        </Col>
      </Row>
    </div>
  )
}

export default Preview
